require('element-remove');
require('custom-event-polyfill');
require('url-polyfill');
require('intersection-observer');

const objectFitImages = require('object-fit-images');

// https://github.com/bfred-it/object-fit-images
// automagically transformed by https://github.com/ronik-design/postcss-object-fit-images
objectFitImages();
const images = [...document.querySelectorAll('img')];
images.forEach(image =>
  image.addEventListener('contextmenu', e => e.preventDefault())
);
